// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class DOMError<T extends Record<string, any> = Record<string, any>> extends Error {
  constructor(
    message?: string,
    public readonly extra?: T
  ) {
    super(message);
  }
}

export interface IErrorWithStatus extends Error {
  status?: number;
  data?: {
    ok: boolean;
    data: Record<string, string | boolean | object | number>;
    [key: string]: string | boolean | object | number | Record<string, string | object | number>;
  };
}

export function isReduxError(error: unknown): error is IErrorWithStatus {
  return (
    typeof error === 'object' &&
    error !== null &&
    'data' in error &&
    typeof error.data === 'object' &&
    'status' in error &&
    typeof error.status === 'number'
  );
}
